var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrane = function SvgCrane(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14827_1805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.142 9.55395H38.8V22.8973H43.1648V23.0516H45.6852V34.9596L43.9413 43.1707H43.1648V44.6569H39.9925V45.3039L45.945 46.1101L47.243 54.3362L47.253 54.3949V62.1869L47.241 62.2546L45.7838 70.3442H26.6899L25.2207 62.1182V54.804L25.2277 54.7502L26.453 46.0375L32.4812 45.2879V44.6569H29.3098V43.1707H28.5643L26.8193 34.9576V23.0516H29.3098V22.8973H33.6777V9.55395H34.3306V2.34424H38.142V9.55395Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7757 69.1741H27.6904L26.418 62.0429V54.9185L27.5102 47.1468L36.3322 46.0498L44.8949 47.2097L46.0491 54.5182V62.1096L44.7757 69.1741Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1332 46.2529V50.4828L26.9609 51.454L27.5395 47.1469L33.1332 46.2529Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3574 46.2529V50.4828L45.5297 51.454L44.9512 47.1469L39.3574 46.2529Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0156 43.2006H43.9382L45.6824 34.9896V23.0815H43.0156V43.2006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4861 43.2006H28.5615L26.8164 34.9877V23.0815H29.4861V43.2006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1261 46.7541L36.3351 45.6104L45.2761 46.8208L46.4856 54.4847V62.1486L45.1417 69.6096H27.3273L25.9824 62.08V54.8869L27.1261 46.7541Z",
    stroke: "black",
    strokeWidth: 1.52894
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7464 51.1821L44.3049 54.6562V61.9532L43.3185 67.4278H29.1563L28.166 61.8865V55.0412L28.7207 51.1821",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3688 69.5431V56.4341L39.1593 54.3506H33.3768L32.0996 56.5675V69.6098L40.3688 69.5431Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.016 58.7082C31.0603 58.7082 31.9069 57.8616 31.9069 56.8172C31.9069 55.7729 31.0603 54.9263 30.016 54.9263C28.9716 54.9263 28.125 55.7729 28.125 56.8172C28.125 57.8616 28.9716 58.7082 30.016 58.7082Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7271 61.5304C30.2841 61.5304 30.7355 61.079 30.7355 60.5221C30.7355 59.9651 30.2841 59.5137 29.7271 59.5137C29.1702 59.5137 28.7188 59.9651 28.7188 60.5221C28.7188 61.079 29.1702 61.5304 29.7271 61.5304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75 49.5183L33.2025 48.3755",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75 51.4592L33.2025 50.3164",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5726 49.5183L39.1191 48.3755",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5726 51.4592L39.1191 50.3164",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2268 39.2334H33.2441V53.8874H39.2268V39.2334Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1232 23.8174H30.3438V43.6019H42.1232V23.8174Z",
    fill: "#F9BA15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.045 23.8174H30.4219V25.8971H42.045V23.8174Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.869 32.5337H30.5957V36.1393H41.869V32.5337Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3902 23.6968H30.0742V43.9169H42.3902V23.6968Z",
    stroke: "black",
    strokeWidth: 1.53965
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3086 32.3423H42.1624",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3086 36.3442H42.1624",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5408 29.7583H28.5391V35.6647H29.5408V29.7583Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0875 29.7583H42.959V35.6647H44.0875V29.7583Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3021 27.4053H28.166V29.2572H44.3021V27.4053Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 0.967307
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0742 41.9087H42.3902",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0327 10.3477H34.4395V48.9742H38.0327V10.3477Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8362 45.8779H34.6348V48.7592H37.8362V45.8779Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7338 13.0806L34.6543 16.1591",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7338 10.0386L34.6543 13.1181",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7338 16.1206L34.6543 19.1991",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7338 19.1616L34.6543 22.2411",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7339 22.2026L35.7324 24.2423",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7542 24.2417H34.8301",
    stroke: "black",
    strokeWidth: 0.769823
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3764 3.13867H35.0938V10.3222H37.3764V3.13867Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14827_1805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "crane.a5a810f03d3b18cfc29117c8c6df8c54.svg";